import { useState } from "react"
import { useTranslation } from "react-i18next";

export const useValidateDynamicForm = (initialState = {}) => {
    const { t } = useTranslation();
    const [errorInputs, setErrorInputs] = useState(initialState);

    const resetErrors = () => {
        setErrorInputs(initialState);
    }

    const handleErrorInput = (input, { isError = false, messageError = '' }) => {
        setErrorInputs((prevErrorInputs) => ({
            ...prevErrorInputs,
            [input]: {
                isError,
                messageError
            }
        }));
    }

    const isValidEmail = (field, email, msgError = '') => {
        if ((email === null || email === undefined || email.toString().trim() === '')) {
            handleErrorInput(field.id, { isError: true, messageError: msgError || t('validation.requiredField', { name: field.label }) });
            return false;
        }
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(email)) {
            handleErrorInput(field.id, { isError: true, messageError: msgError || t('validation.invalidEmail', { name: field.label }) });
            return false;
        }

        handleErrorInput(field.id, { isError: false, messageError: '' });
        return true;
    };

    const validDate = (name, dt, msgError = '') => {
        const date = new Date(dt);
        if (isNaN(date.getTime())) {
            handleErrorInput(name, { isError: true, messageError: msgError || t('validation.invalidDate', { name: name }) });
            return false;
        }
        return true;
    }

    const validField = (name, value, validation = null, msgError = '') => {
        const isEmptyCollection =
            (Array.isArray(value) && value.length === 0) ||
            (value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);
        if ((value === null || value === undefined || value.toString().trim() === '' || isEmptyCollection) && !validation) {
            handleErrorInput(name, { isError: true, messageError: msgError || t('validation.requiredField', { name: name }) });
            return false;
        } else {
            handleErrorInput(name, { isError: false, messageError: '' });
            return true;
        }
    };

    const validForm = (scheme, data, validation = null) => {
        let valid = true;
        scheme.forEach((item) => {
            if (item?.required) {
                if (item.type === 'date') {
                    if (!validDate(item.id, data[item.id], item?.requiredMessage)) valid = false;
                }
                else if (item.type === 'email') {
                    if (!isValidEmail(item, data[item.id], item?.requiredMessage)) valid = false;
                }
                else {
                    if (!validField(item.id, data[item.id], validation, item?.requiredMessage)) valid = false;
                }
            }
        });
        return valid;
    };

    return [errorInputs, validForm, resetErrors, handleErrorInput];
}